var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFivbLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 22,
    viewBox: "0 0 59 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo fivb 1",
    clipPath: "url(#clip0_1188_13536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO FIVB BYLINE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1188_13536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -14,
    y: -14,
    width: 86,
    height: 49
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.5249 -13.0414H-13.0037V34.0737H71.5249V-13.0414Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1188_13536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1188_13536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -14,
    y: -14,
    width: 86,
    height: 49
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clip-path_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M71.5249 -13.0414H-13.0037V34.0737H71.5249V-13.0414Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1188_13536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.5907 6.10352e-05H23.9633V13.0435H20.5907V6.10352e-05ZM9.75483 4.83058H18.4247V7.7289H13.1235V13.0435H9.75284L9.75483 4.83058ZM19.386 2.89838H9.75483V6.10352e-05H19.386V2.89838ZM47.4798 6.36075C47.8742 6.06915 48.1958 5.68979 48.4194 5.25249C48.6429 4.8152 48.7623 4.33187 48.7682 3.84048C48.7682 1.44022 47.1986 0.00806208 44.5798 0.00806208H33.9195L31.4464 8.27296H31.4085L28.9354 6.10352e-05H25.1659V2.89838H26.3725L29.7472 13.0435H33.1098L36.4844 2.89838H44.2049C45.242 2.89838 45.4016 3.58045 45.4016 3.98449C45.4016 4.38854 45.248 5.07261 44.2049 5.07261H38.421V7.97092H44.3605C45.3976 7.97092 45.5571 8.651 45.5571 9.05704C45.5571 9.46309 45.4016 10.1452 44.3605 10.1452H38.411V13.0435H44.8351C47.3302 13.0435 48.9417 11.5113 48.9417 9.13905C48.9417 7.44287 48.0422 6.72079 47.4758 6.35275M29.2605 15.9418C18.7757 15.9418 8.85135 17.692 0 20.8143V21.0303C9.58578 18.7442 19.4075 17.6029 29.2605 17.63C39.1136 17.6027 48.9353 18.7441 58.521 21.0303V20.8143C49.6717 17.692 39.7453 15.9418 29.2605 15.9418ZM49.1112 13.0395V11.9734H48.7582V11.8313H49.5999V11.9734H49.2488V13.0395H49.1112ZM49.7395 13.0395V11.8393H49.9509L50.2102 12.6954C50.2281 12.7754 50.2461 12.8355 50.258 12.8715C50.272 12.8294 50.2899 12.7674 50.3159 12.6714L50.5751 11.8333H50.7626V13.0335H50.619V12.0334L50.3039 13.0335H50.1783L49.8711 12.0054V13.0335L49.7395 13.0395Z",
    fill: "#2732D4"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_13536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.519,
    height: 21.0303,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFivbLogoSmall);
export default __webpack_public_path__ + "static/media/fivb-logo-small.2f77c380c9153e51b667abe59f665e5d.svg";
export { ForwardRef as ReactComponent };